import React, { useState, cloneElement, useEffect } from 'react'
import { styled, SxProps } from '@mui/material/styles'
import FormItem from './formItem'

export interface FormProps {
  initialValue: unknown;
  children: React.ReactElement | React.ReactElement[];
  onFormValueChange?: (formValue: unknown) => void;
  validating?: boolean;
  onValidate?: (formValue: unknown) => void;
  sx?: SxProps;
}

export const FormComponent = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
}))

const flatChildren = (children: React.ReactElement[]) => {
  let childrenArray: React.ReactElement[] = []
  children.forEach((child) => {
    if (
      child.props &&
      Object.keys(child.props)?.length == 1 &&
      Object.keys(child.props)?.[0] === 'children'
    ) {
      if (typeof child.props.children === 'string') {
        childrenArray.push(child)
      } else {
        childrenArray = childrenArray.concat(child.props.children)
      }
    } else {
      childrenArray.push(child)
    }
  })
  return childrenArray
}

const Form: React.FC<FormProps> = (props) => {
  const {
    initialValue,
    onFormValueChange,
    children,
    validating,
    onValidate,
    sx,
  } = props
  const [formValue, setFormValue] = useState(initialValue)
  const [hasError, setHasError] = useState<boolean>()

  const handleFormItemChange = (formItemValue: unknown) => {
    setFormValue({ ...(formValue as object), ...(formItemValue as object) })
  }

  const handleFormValidationChange = (value: { [key: string]: boolean }) => {
    const result = Object.values(value)?.[0]
    if (!result) {
      setHasError(true)
    } else {
      setHasError(false)
    }
  }

  useEffect(() => {
    onFormValueChange && onFormValueChange(formValue)
  }, [formValue])

  useEffect(() => {
    onValidate && onValidate(hasError)
  }, [hasError])

  useEffect(() => {
    setFormValue(initialValue)
  }, [initialValue])

  return (
    <FormComponent sx={sx}>
      {Array.isArray(children)
        ? flatChildren(children)?.map((child, index) => {
            if (child?.props) {
              // console.log(child);
              //TODO 判断 child的type 不是rfc的就不给多余的属性
              if (typeof child.type === 'string') {
                return cloneElement(child, {
                  key: `form-item-${index}`,
                     // @ts-ignore
                  value: formValue?.[child.props.label],
                  onChange: handleFormItemChange,
                })
              }
              return cloneElement(child, {
                key: `form-item-${index}`,
                   // @ts-ignore
                value: formValue?.[child.props.label],
                onChange: handleFormItemChange,
                validating: validating,
                ...(child.props?.label && {
                  onValidate: handleFormValidationChange,
                }),
              })
            } else {
              return cloneElement(child, {})
            }
          })
        : cloneElement(children, {
            key: 'form-item',
               // @ts-ignore
            value: formValue?.[children.props.label],
            onChange: handleFormItemChange,
            validating: validating,
            onValidate: handleFormValidationChange,
          })}
    </FormComponent>
  )
}

export { FormItem }
export default Form
